import { isSsr } from '@lemonade-hq/cdk';
import { useMemo } from 'react';

// TODO: monolu!
export function prefersReducedMotion(): boolean {
  if (isSsr()) return false;
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  return mediaQuery.matches;
}

function usePrefersReducedMotion(): boolean {
  return useMemo(prefersReducedMotion, []);
}

export default usePrefersReducedMotion;
